import Cadastre from "../../../components/Property/Cadastre";
import useTranslator from "../../../hooks/useTranslator";
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import i18next from "i18next";
import {
  haveValue,
  renderErrorMessage,
  validateJOIProperty,
  validateJOIFormField,
  toast,
} from "../../../helper/common";
import TenantContext from "../../../context/tenant/TenantContext";
import AuthContext from "../../../context/auth/AuthContext";
import constants from "../../../Utils/constants";
import moment from "moment";
import LandLordContext from "../../../context/landlord/LandLordContext";
import * as Joi from "joi-browser";
import CardSelect from "../../../components/Tenant/CardSelect";
import RentMonthPaidModal from "../../../components/Tenant/RentMonthPaidModal";
import AuthStepHeader from "../../../components/Auth/AuthStepHeader";
import {
  Button,
  Card,
  Icon,
  InfoList,
  LanguageSwitch,
  Modal,
  Notice,
  ProgressRail,
  Select,
  StepList,
  TextField,
} from "../../../components/design";
import "./tenantRentalStep.css";

const TenantRentalStep = () => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const tenantContext = useContext(TenantContext);
  const landLordContext = useContext(LandLordContext);
  const { fetchAssignedDetails } = landLordContext;
  const { user, setLoading, changeUserLng } = authContext;
  const { rePayRent, rentPayment, getRentalInfo, ledgerData } = tenantContext;
  const queryParameters = new URLSearchParams(window.location.search);
  const payment_success_check = queryParameters.get("success");
  const repay_check_success = queryParameters.get("repay");
  const revisit_payment = queryParameters.get("revisit");
  const Months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const defaultStateProp = {
    street_type: "",
    street: "",
    street_number: "",
    postcode: "",
    staircase: "",
    floor: "",
    door: "",
    municipality: "",
    province: "",
    code_ine: "",
    code_via: "",
    cadastral_reference: "",
    area: "",
    property_reference: "",
  };
  const defaultForm = {
    ...defaultStateProp,
    landlord_fname: "",
    landlord_lname: "",
    landlord_email: "",
    landlord_account_number: "",
    rent_amount: null,
    deposit_amount: 0,
    rent_date: null,
    selected_month: "",
  };
  const [formData, setFormData] = useState(defaultForm);
  const [step, setStep] = useState(1);
  const [currentStep, setCurrentStep] = useState(0);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [errors, setErrors] = useState({});
  const [isDomesticCard, setIsDomesticCard] = useState(null);
  const [cardModal, setCardModal] = useState(false);
  const [continueModal, setContinueModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [notFoundModal, setNotFoundModal] = useState(false);
  const [paying, setPaying] = useState(false);
  const [currentLang, setCurrentLang] = useState(
    () => localStorage.getItem("i18nextLng")?.toLowerCase() || "es"
  );
  const [isLangChanging, setIsLangChanging] = useState(false);

  useEffect(() => {
    if (haveValue(repay_check_success)) {
      if (repay_check_success == true || repay_check_success == "true") {
        setCurrentStep(5);
      }
    }
    if (haveValue(payment_success_check)) {
      if (payment_success_check == true || payment_success_check == "true") {
        localStorage.removeItem("rental_info");
        setCurrentStep(5);
      }
      if (payment_success_check == false || payment_success_check == "false") {
        setCurrentStep(0);
        const prefilled_vals = localStorage.getItem("rental_info");
        if (haveValue(prefilled_vals)) {
          setFormData(JSON.parse(prefilled_vals));
        }
        toast.error(_t("paymentFailed"));
      }
    }
    if (haveValue(revisit_payment) && revisit_payment) {
      setLoading(true);
      setCurrentStep(6);
      setIsEdit(true);
    } else {
      setIsEdit(false);
    }

    ledgerData()
      .then((res) => {
        const data = res.success_res;
        const temp_data = data.filter(
          (val) => val.status == constants.COMPLETED
        );
        setPaymentHistory(temp_data);
      })
      .catch((err) => {
        console.log(err, "Error in ledgerData");
      });
  }, []);

  useEffect(() => {
    if (user?.rental_data?.type == constants.RENTAL_INFO) {
      getRentalInfo()
        .then((res) => {
          setFormData(res.success_res);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(true);
          console.log(err);
        });
    } else if (user?.rental_data?.type == constants.ASSIGNED_PROPERTY) {
      fetchAssignedDetails(user?.rental_data?.id)
        .then((res) => {
          setFormData(res.result);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(true);
          console.log(err);
        });
    } else {
      if (haveValue(user)) {
        setLoading(false);
        setIsEdit(false);
        setCurrentStep(0);
        setStep(1);
      }
    }
  }, [user]);

  const navigateHome = () => {
    navigate("/tenant");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name == "landlord_account_number") {
      const temp = value.split(" ").join("");
      e.target.value = temp;
      setFormData((prevData) => ({ ...prevData, [name]: temp }));
    } else {
      setFormData((prevData) => ({ ...prevData, [name]: value }));
    }
    if (name in formData) {
      const errorData = { ...errors };
      const errorMessage = validateJOIProperty(getFieldsSchema(), e);
      if (errorMessage) {
        errorData[name] = errorMessage;
      } else {
        errorData[name] && delete errorData[name];
      }
      setErrors(errorData);
    }
  };

  const handleMonthChange = (e) => {
    const { name, value } = e.target;
    const rent_date = moment().month(value).format("YYYY-MM-DD");
    setFormData((prevData) => ({
      ...prevData,
      [name]: rent_date,
      selected_month: value,
    }));
  };

  const handleGoNext = () => {
    let errors = validateJOIFormField(formData, getFieldsSchema());
    if (errors) {
      setErrors(errors);
      return;
    }
    if (
      currentStep == 1 &&
      (!haveValue(formData?.street_type) ||
        !haveValue(formData?.street) ||
        !haveValue(formData?.street_number) ||
        !haveValue(formData?.floor) ||
        !haveValue(formData?.door) ||
        !haveValue(formData?.province) ||
        !haveValue(formData?.postcode))
    ) {
      setNotFoundModal(true);
      return;
    }
    setCurrentStep((prev) => ++prev);
  };

  const handleGoBack = () => {
    setCurrentStep((prev) => --prev);
  };

  const handleGoBackCadastre = () => {
    setCurrentStep((prev) => --prev);
    setStep(1);
  };

  const handlePaymentInitiate = () => {
    setPaying(true);
    const temp = {
      ...formData,
      tenant_id: localStorage.getItem("saveduserid"),
      isDomesticCard,
    };
    localStorage.setItem("rental_info", JSON.stringify(temp));
    rentPayment(temp)
      .then((res) => {
        window.location.replace(res.success_res.session.url);
      })
      .catch((err) => {
        console.log(err);
        setPaying(false);
      });
  };

  const navigateBackHome = () => {
    navigate("/tenant");
  };

  const getPaymentMonthOptions = () => {
    const currentMonth = moment().month();
    const previousMonth = moment().clone().subtract(1, "months").month();
    const nextMonth = moment().clone().add(1, "months").month();

    return [previousMonth, currentMonth, nextMonth].map((month) => ({
      value: String(month),
      label: _t(Months[month], "", "fixed"),
    }));
  };

  const handleLanguageChange = async (lang) => {
    if (isLangChanging) return;
    setIsLangChanging(true);
    try {
      await i18next.changeLanguage(lang);
      try {
        await changeUserLng?.({ skipUserLoad: true });
      } catch {}
      setCurrentLang(lang.toLowerCase());
    } finally {
      setIsLangChanging(false);
    }
  };

  const initiateNewFlow = () => {
    setCurrentStep(0);
    setIsEdit(false);
    if (user?.rental_data?.type != constants.RENTAL_INFO) {
      setFormData(defaultForm);
    }
  };

  const changeMonthAndYear = (dateString, newMonth) => {
    const date = moment(dateString);
    const currentYear = moment().year();

    date.month(newMonth); // Set the new month (0-11)
    date.year(currentYear); // Set the current year

    return date.toISOString(); // Return the updated date as an ISO string
  };

  const rePaymentRent = () => {
    setPaying(true);
    const originalDate = formData?.rent_date;
    const newMonth = +selectedMonth;
    var rent_date = changeMonthAndYear(originalDate, newMonth);

    const temp = {
      tenant_id: localStorage.getItem("saveduserid"),
      rental_info_id: user?.rental_data?.id,
      rent_date,
      isDomesticCard,
    };
    rePayRent(temp)
      .then((res) => {
        window.location.replace(res.success_res.session.url);
      })
      .catch((err) => {
        console.log(err);
        setPaying(false);
      });
  };

  //Schema
  const getFieldsSchema = () => {
    return {
      landlord_account_number: Joi.string()
        .length(24)
        .regex(/^ES\d{22}$/)
        .required()
        .error((errors) => {
          // Return the same error message for all validation errors
          errors.forEach((err) => {
            err.message = _t(
              "theAccountNumberMustBeExactlyTwentyFourCharactersLongAndStartWithESFollowedByTwentyTwoDigits"
            );
          });
          return errors;
        }),
    };
  };

  const handlePayRent = () => {
    var already_found = false;
    for (let val of paymentHistory) {
      if (
        selectedMonth == moment(val.processing_date).month() &&
        moment(val.processing_date).year() == moment().year()
      ) {
        already_found = true;
        break;
      }
    }
    if (already_found) {
      setContinueModal(true);
    } else {
      // setCardModal(true);
      isEdit ? rePaymentRent() : handlePaymentInitiate();
    }
  };

  const steps = [
    { id: "landlord", title: _t("landlordDetails") },
    { id: "address", title: _t("address") },
    { id: "payments", title: _t("rentalPayments") },
    { id: "month", title: _t("paymentMonth") },
    { id: "review", title: _t("review") },
  ];
  // step 5 (done) and step 6 (review of saved details) sit on the last rail step
  const activeIndex = Math.min(currentStep, steps.length - 1);

  const formatStreetNumber = (value) =>
    Number.isNaN(parseInt(value, 10)) ? "N/A" : String(parseInt(value, 10));

  const getRentalAddress = () => {
    if (currentStep == 4) {
      return `${formData?.street_type}, ${formData?.street} ${formatStreetNumber(
        formData?.street_number
      )}, ${formData?.floor} - ${formData?.door} ${formData?.province}, ${
        formData?.postcode
      }`;
    }
    if (user?.rental_data?.type == constants.RENTAL_INFO) {
      return `${formData?.street} ${formatStreetNumber(
        formData?.street_number
      )}, ${formData?.floor_number} - ${formData?.flat_number} ${
        formData?.province
      }, ${formData?.postcode}`;
    }
    const property = formData?.property_id;
    return `${property?.street} ${formatStreetNumber(
      property?.street_number
    )}, ${property?.floor_number} - ${property?.flat_number} ${
      property?.province
    }, ${property?.postcode}`;
  };

  const isRentalInfo = user?.rental_data?.type == constants.RENTAL_INFO;
  const isRepaySuccess =
    repay_check_success == true || repay_check_success == "true";

  const depositItems = haveValue(formData?.deposit_amount)
    ? [{ label: _t("depositAmount"), value: `€${formData?.deposit_amount}` }]
    : [];

  const reviewItems =
    currentStep == 4
      ? [
          { label: _t("address"), value: getRentalAddress() },
          { label: _t("paymentDate"), value: formData?.rent_date },
          {
            label: _t("rentalPaymentAmount"),
            value: `€${formData?.rent_amount}`,
          },
          ...depositItems,
        ]
      : [
          { label: _t("address"), value: getRentalAddress() },
          {
            label: _t("landlordName"),
            value: isRentalInfo
              ? `${formData?.landlord_fname} ${formData?.landlord_lname}`
              : `${formData?.landlord_id?.fname_companyName} ${formData?.landlord_id?.lname}`,
          },
          {
            label: _t("landlordEmail"),
            value: isRentalInfo
              ? formData?.landlord_email
              : formData?.landlord_id?.email,
          },
          {
            label: _t("rentalPaymentAmount"),
            value: `€${formData?.rent_amount}`,
          },
          ...depositItems,
        ];

  const monthOptions = getPaymentMonthOptions();

  return (
    <>
      <div className="tenant-onboarding-shell">
        <ProgressRail
          label={_t("yourProcess", "Your process")}
          steps={steps}
          activeIndex={activeIndex}
          language={
            <LanguageSwitch
              currentLang={currentLang}
              isLangChanging={isLangChanging}
              onChange={handleLanguageChange}
            />
          }
        >
          <p className="onboarding-progress__eyebrow">
            {_t("monthlyRentPayment")}
          </p>
          <StepList
            steps={steps}
            activeIndex={activeIndex}
            completedLabel={_t("completed", "Completed")}
          />
        </ProgressRail>

        <main className="rentalStep__page">
          {currentStep == 0 && (
            <div className="rentalStep__col">
              <AuthStepHeader
                onBack={navigateHome}
                title={_t("landlordDetails")}
                subtitle={_t("rentalStepLandlordSub")}
              />
              <form
                noValidate
                onSubmit={(e) => {
                  e.preventDefault();
                  handleGoNext();
                }}
              >
                <div className="rentalStep__row">
                  <TextField
                    id="rental-landlord-fname"
                    name="landlord_fname"
                    label={_t("firstName")}
                    value={formData.landlord_fname ?? ""}
                    onChange={handleInputChange}
                    required
                    placeholder={_t("enterFirstName")}
                  />
                  <TextField
                    id="rental-landlord-lname"
                    name="landlord_lname"
                    label={_t("lastName")}
                    value={formData.landlord_lname ?? ""}
                    onChange={handleInputChange}
                    required
                    placeholder={_t("enterLastName")}
                  />
                </div>
                <TextField
                  id="rental-landlord-email"
                  name="landlord_email"
                  type="email"
                  label={_t("email")}
                  icon={<Icon name="mail" />}
                  value={formData.landlord_email ?? ""}
                  onChange={handleInputChange}
                  required
                  placeholder={_t("enterEmail")}
                />
                <TextField
                  id="rental-landlord-account"
                  name="landlord_account_number"
                  className="rentalStep__field--wrap"
                  label={_t("bankAccountNumber")}
                  value={formData.landlord_account_number ?? ""}
                  onChange={handleInputChange}
                  required
                  placeholder={_t("xxxxxxxxxxxx")}
                  error={renderErrorMessage(errors, "landlord_account_number")}
                />
                <Button
                  type="submit"
                  size="lg"
                  block
                  iconEnd={<Icon name="arrowRight" size={18} />}
                  disabled={
                    !haveValue(formData.landlord_fname) ||
                    !haveValue(formData.landlord_lname) ||
                    !haveValue(formData.landlord_email) ||
                    !haveValue(formData.landlord_account_number)
                  }
                >
                  {_t("next")}
                </Button>
              </form>
            </div>
          )}
          {currentStep == 1 && (
            <Cadastre
              step={step}
              setStep={setStep}
              formData={formData}
              setFormData={setFormData}
              handleInputChange={handleInputChange}
              defaultState={defaultStateProp}
              handleShow={handleGoNext}
              handleSubmit={handleGoNext}
              handleBackCurrent={handleGoBack}
            />
          )}
          {currentStep == 2 && (
            <div className="rentalStep__col">
              <AuthStepHeader
                onBack={handleGoBackCadastre}
                title={_t("tellUsAboutYourRentalPayments")}
                subtitle={_t("rentalStepPaymentsSub")}
              />
              <form
                noValidate
                onSubmit={(e) => {
                  e.preventDefault();
                  handleGoNext();
                }}
              >
                <TextField
                  id="rental-amount"
                  name="rent_amount"
                  type="number"
                  inputMode="decimal"
                  label={_t("rentalPaymentAmount")}
                  value={formData.rent_amount ?? ""}
                  onChange={handleInputChange}
                  required
                  placeholder={_t("enterPaymentAmount")}
                  trailing={<span className="rentalStep__unit">€</span>}
                />
                <TextField
                  id="rental-deposit"
                  name="deposit_amount"
                  type="number"
                  inputMode="decimal"
                  label={_t("depositAmountOptional")}
                  value={formData.deposit_amount ?? ""}
                  onChange={handleInputChange}
                  placeholder={_t("enterDepositAmountOptional")}
                  trailing={<span className="rentalStep__unit">€</span>}
                />
                <Button
                  type="submit"
                  size="lg"
                  block
                  iconEnd={<Icon name="arrowRight" size={18} />}
                  disabled={!haveValue(formData.rent_amount)}
                >
                  {_t("next")}
                </Button>
              </form>
            </div>
          )}
          {currentStep == 3 && (
            <div className="rentalStep__col">
              <AuthStepHeader
                onBack={handleGoBack}
                title={_t("payRentFor")}
                subtitle={_t("rentalStepMonthSub")}
              />
              <form
                noValidate
                onSubmit={(e) => {
                  e.preventDefault();
                  handleGoNext();
                }}
              >
                <Select
                  id="rental-month"
                  name="rent_date"
                  label={_t("paymentMonth")}
                  placeholder={_t("selectPaymentMonth")}
                  required
                  value={formData.selected_month ?? ""}
                  onChange={handleMonthChange}
                  options={monthOptions}
                />
                <Button
                  type="submit"
                  size="lg"
                  block
                  iconEnd={<Icon name="arrowRight" size={18} />}
                  disabled={
                    !haveValue(formData.rent_date) ||
                    !haveValue(formData.selected_month)
                  }
                >
                  {_t("next")}
                </Button>
              </form>
            </div>
          )}
          {currentStep == 4 && (
            <div className="rentalStep__col rentalStep__col--wide">
              <AuthStepHeader
                onBack={handleGoBack}
                title={_t("reviewLeaseInformation")}
                subtitle={_t("rentalStepReviewSub")}
              />
              <Card as="div" className="rentalStep__review">
                <InfoList items={reviewItems} layout="stacked" />
              </Card>
              <Notice>{_t("protectYourHomeAndYourStuffInMinutes")}</Notice>
              <Button
                size="lg"
                block
                loading={paying}
                onClick={isEdit ? rePaymentRent : handlePaymentInitiate}
              >
                {_t("proceedToPay")}
              </Button>
            </div>
          )}
          {currentStep == 5 && (
            <div className="rentalStep__col rentalStep__col--center">
              <span className="rentalStep__done-icon">
                <Icon name="checkCircle" size={28} />
              </span>
              <header className="auth-step-header">
                <h2 className="auth-step-title">{_t("congratulations")}</h2>
                <p className="auth-step-sub">
                  {isRepaySuccess
                    ? _t(
                        "youHaveCompletedYourMonthlyRentPaymentSetUpAndHaveBeenRewardedWithTenSkorPoints"
                      )
                    : _t(
                        "youHaveCompletedYourMonthlyRentPaymentSetUpAndHaveBeenRewardedWithHundredPoints"
                      )}
                </p>
              </header>
              <Button size="lg" block onClick={navigateBackHome}>
                {_t("goBackHome")}
              </Button>
            </div>
          )}
          {currentStep == 6 && (
            <div className="rentalStep__col rentalStep__col--wide">
              <AuthStepHeader
                onBack={navigateHome}
                title={_t("reviewLeaseInformation")}
                subtitle={_t("rentalStepReviewSub")}
              />
              <Card as="div" className="rentalStep__review">
                <InfoList items={reviewItems} layout="stacked" />
              </Card>
              <Select
                id="rental-pay-month"
                label={_t("paymentMonth")}
                placeholder={_t("selectPaymentMonth")}
                value={selectedMonth ?? ""}
                onChange={(e) => setSelectedMonth(e.target.value)}
                options={monthOptions}
              />
              <Notice>{_t("protectYourHomeAndYourStuffInMinutes")}</Notice>
              <div className="rentalStep__actions">
                <Button
                  size="lg"
                  block
                  loading={paying}
                  onClick={handlePayRent}
                  disabled={!haveValue(selectedMonth)}
                >
                  {_t("proceedToPay")}
                </Button>
                <Button
                  variant="secondary"
                  size="lg"
                  block
                  onClick={initiateNewFlow}
                >
                  {_t("editDetails")}
                </Button>
              </div>
            </div>
          )}
        </main>
      </div>

      {cardModal && (
        <CardSelect
          cardModal={cardModal}
          setCardModal={setCardModal}
          setIsDomesticCard={setIsDomesticCard}
          isDomesticCard={isDomesticCard}
          proceedPayment={isEdit ? rePaymentRent : handlePaymentInitiate}
        />
      )}
      {continueModal && (
        <RentMonthPaidModal
          show={continueModal}
          handleClose={(e) => setContinueModal(false)}
          handleContinue={(e) => {
            setContinueModal(false);
            // setCardModal(true);
            isEdit ? rePaymentRent() : handlePaymentInitiate();
          }}
        />
      )}
      <Modal
        open={notFoundModal}
        onClose={() => setNotFoundModal(false)}
        size="sm"
        title={_t("unableToFetchPropertyDetailsWithGivenCadastreReference")}
        actionsLayout="stack"
        actions={
          <Button
            size="lg"
            onClick={() => {
              setStep(3);
              setNotFoundModal(false);
            }}
          >
            {_t("enterManually")}
          </Button>
        }
      />
    </>
  );
};

export default TenantRentalStep;
